var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 18.3337H3.33332C2.88672 18.3492 2.45372 18.1786 2.13773 17.8626C1.82174 17.5466 1.65113 17.1136 1.66665 16.667V8.33366C1.65113 7.88705 1.82174 7.45405 2.13773 7.13806C2.45372 6.82208 2.88672 6.65147 3.33332 6.66699H6.66665V3.33366C6.65113 2.88705 6.82174 2.45405 7.13773 2.13806C7.45372 1.82208 7.88672 1.65147 8.33332 1.66699H16.6667C17.1133 1.65147 17.5463 1.82208 17.8622 2.13806C18.1782 2.45405 18.3488 2.88705 18.3333 3.33366V11.667C18.3486 12.1135 18.1779 12.5464 17.862 12.8623C17.546 13.1782 17.1132 13.3489 16.6667 13.3337H13.3333V16.667C13.3486 17.1135 13.1779 17.5464 12.862 17.8623C12.546 18.1782 12.1132 18.3489 11.6667 18.3337ZM3.33332 8.33366V16.667H11.6667V13.3337H8.33332C7.88679 13.3489 7.45393 13.1782 7.138 12.8623C6.82207 12.5464 6.65138 12.1135 6.66665 11.667V8.33366H3.33332ZM8.33332 3.33366V11.667H16.6667V3.33366H8.33332Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.942556a9d91c2ea3c8d5ba3c4c48e6c0.svg";
export { ForwardRef as ReactComponent };